module.exports = __webpack_public_path__ + "img/Y2KCY1.0089f767.jpg";